import React, { useState } from 'react';
import styles from "assets/scss/task_management.module.css";
import { getOverdueTime } from "services/util";
import TeamProgressModal from './TeamProgressModal';

function TeamProgressCard({ task, fetchLabels, groups, buckets, userPermission, activeTab, fetchEmployees }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null);

    const defaultOptions = task?.task_label?.map(label => {
        return { value: label?.id, label: label?.label_name, color_code: label?.color_code };
    });


    const overdueTime = getOverdueTime(task?.end_date);
    const dueClass = task.end_date ? (new Date(task.end_date) < new Date() ? styles.duePassed : styles.dueUpcoming) : styles.noDueDate;

    const handleTaskCardClick = (task) => {
        setSelectedTask(task);
        setIsModalOpen(true);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <div className={styles.card} onClick={() => handleTaskCardClick(task)}>
            <div className='d-flex justify-content-start flex-wrap'>
                <div className='mt-2 ml-2 d-flex justify-content-start flex-wrap align-items-start'>
                    {defaultOptions?.map((i) => (
                        <span
                            key={i?.value}
                            style={{
                                borderRadius: '10%',
                                backgroundColor: i?.color_code || '',
                                marginRight: "3px",
                            }}
                            className='p-1 mt-1'>
                            {i?.label}
                        </span>
                    ))}
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.radioTitle}>
                    <span className={styles.taskTitle}>{task.bucket_task_name ? task.bucket_task_name : ""}</span>
                </div>
            </div>
            <div className={styles.line}></div>
            <div className={styles.bottom_line}>
                <div className={`styles.dueDate px-1 py-1`}>
                    <button className={dueClass}>
                        {task.end_date ? new Date(task.end_date).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' }) : "Due"}
                    </button>
                    {overdueTime && (
                        <span className={`${dueClass} mx-1`} style={{paddingTop: "2px", paddingBottom: "2px"}}>{overdueTime}</span>
                    )}
                </div>
            </div>
            {isModalOpen && (
                <TeamProgressModal
                    task={selectedTask}
                    onClick={() => handleTaskCardClick(task)}
                    onClose={toggleModal}
                    availableEmployees={fetchEmployees}
                    fetchLabels={fetchLabels}
                    groups={groups}
                    buckets={buckets}
                    userPermission={userPermission}
                    activeTab={activeTab}
                />
            )}
        </div>
    );
}

export default TeamProgressCard;
